import * as Netfunnel from '@ecp/common/src/utils/netfunnel.d.ts';

export const setActionId = () => {
  let action_id = Netfunnel.Get_Action_Id();
  let href = window.location.href;
  // 접속도메인별로 넷퍼넬 action_id 값을 변경처리
  if (href.indexOf('//localhost') > 0 || href.indexOf('//stgfo.welstorymall.com') > 0) { //테스트
    action_id = 'index_test';
  } else if (
    href.indexOf('//skypass.welstorymall.com') > 0 ||
    href.indexOf('//stgmtpc5.welstorymall.com') > 0 ||
    href.indexOf('//stgmtmo5.welstorymall.com') > 0 ||
    href.indexOf('//koreanair2.welstorymall.com') > 0
  ) {
    // skypass
    //action_id = 'skypass_index' TODO 추후 변경;
    action_id = 'skypass_index';
  }
  Netfunnel.Set_Action_Id(action_id);

  return action_id;
};
